"use client"
import { combinedLocales } from "@/i18n.config"
import { UNIVERSAL_DEFAULT_LANGUAGE } from "@/lib/siteconfig/constants"
import Link, { LinkProps } from "next/link"
import { usePathname } from "next/navigation"
import React from "react"

interface DynamicLinkProps extends LinkProps {
    children: React.ReactNode
    prefetch?: boolean | null
    href: string
    className?: string
    [key: string]: any
}

const DynamicLink: React.FC<DynamicLinkProps> = ({
    children,
    prefetch = true,
    href,
    className,
    ...linkProps
}) => {
    const path = usePathname()
    const shouldNotPrefetch = process.env.NEXT_PUBLIC_PREFETCH === "false"
    const currentLocale = path.split("/")[1]
    const resolvedLocale = combinedLocales.includes(currentLocale)
        ? currentLocale
        : UNIVERSAL_DEFAULT_LANGUAGE
    const uri = `/${resolvedLocale}${href}`

    return (
        <Link
            {...linkProps}
            className={className}
            href={uri}
            prefetch={shouldNotPrefetch ? false : prefetch}
        >
            {children}
        </Link>
    )
}

export default DynamicLink
